/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ObservableLevelResponse } from './ObservableLevelResponse';
import {
    ObservableLevelResponseFromJSON,
    ObservableLevelResponseFromJSONTyped,
    ObservableLevelResponseToJSON,
    ObservableLevelResponseToJSONTyped,
} from './ObservableLevelResponse';
import type { PartCategoryResponse } from './PartCategoryResponse';
import {
    PartCategoryResponseFromJSON,
    PartCategoryResponseFromJSONTyped,
    PartCategoryResponseToJSON,
    PartCategoryResponseToJSONTyped,
} from './PartCategoryResponse';
import type { PartManufacturerResponse } from './PartManufacturerResponse';
import {
    PartManufacturerResponseFromJSON,
    PartManufacturerResponseFromJSONTyped,
    PartManufacturerResponseToJSON,
    PartManufacturerResponseToJSONTyped,
} from './PartManufacturerResponse';
import type { PartLocationResponse } from './PartLocationResponse';
import {
    PartLocationResponseFromJSON,
    PartLocationResponseFromJSONTyped,
    PartLocationResponseToJSON,
    PartLocationResponseToJSONTyped,
} from './PartLocationResponse';
import type { InspectionStatusResponse } from './InspectionStatusResponse';
import {
    InspectionStatusResponseFromJSON,
    InspectionStatusResponseFromJSONTyped,
    InspectionStatusResponseToJSON,
    InspectionStatusResponseToJSONTyped,
} from './InspectionStatusResponse';
import type { DimensionTypeResponse } from './DimensionTypeResponse';
import {
    DimensionTypeResponseFromJSON,
    DimensionTypeResponseFromJSONTyped,
    DimensionTypeResponseToJSON,
    DimensionTypeResponseToJSONTyped,
} from './DimensionTypeResponse';
import type { ObservableActionTypeResponse } from './ObservableActionTypeResponse';
import {
    ObservableActionTypeResponseFromJSON,
    ObservableActionTypeResponseFromJSONTyped,
    ObservableActionTypeResponseToJSON,
    ObservableActionTypeResponseToJSONTyped,
} from './ObservableActionTypeResponse';
import type { SiteDiggingConditionResponse } from './SiteDiggingConditionResponse';
import {
    SiteDiggingConditionResponseFromJSON,
    SiteDiggingConditionResponseFromJSONTyped,
    SiteDiggingConditionResponseToJSON,
    SiteDiggingConditionResponseToJSONTyped,
} from './SiteDiggingConditionResponse';
import type { InspectionCategoryResponse } from './InspectionCategoryResponse';
import {
    InspectionCategoryResponseFromJSON,
    InspectionCategoryResponseFromJSONTyped,
    InspectionCategoryResponseToJSON,
    InspectionCategoryResponseToJSONTyped,
} from './InspectionCategoryResponse';
import type { InspectionTypeResponse } from './InspectionTypeResponse';
import {
    InspectionTypeResponseFromJSON,
    InspectionTypeResponseFromJSONTyped,
    InspectionTypeResponseToJSON,
    InspectionTypeResponseToJSONTyped,
} from './InspectionTypeResponse';
import type { EquipmentTypeResponse } from './EquipmentTypeResponse';
import {
    EquipmentTypeResponseFromJSON,
    EquipmentTypeResponseFromJSONTyped,
    EquipmentTypeResponseToJSON,
    EquipmentTypeResponseToJSONTyped,
} from './EquipmentTypeResponse';
import type { UnitResponse } from './UnitResponse';
import {
    UnitResponseFromJSON,
    UnitResponseFromJSONTyped,
    UnitResponseToJSON,
    UnitResponseToJSONTyped,
} from './UnitResponse';
import type { DataTypeResponse } from './DataTypeResponse';
import {
    DataTypeResponseFromJSON,
    DataTypeResponseFromJSONTyped,
    DataTypeResponseToJSON,
    DataTypeResponseToJSONTyped,
} from './DataTypeResponse';
import type { EquipmentCategoryResponse } from './EquipmentCategoryResponse';
import {
    EquipmentCategoryResponseFromJSON,
    EquipmentCategoryResponseFromJSONTyped,
    EquipmentCategoryResponseToJSON,
    EquipmentCategoryResponseToJSONTyped,
} from './EquipmentCategoryResponse';
import type { PartTypeResponse } from './PartTypeResponse';
import {
    PartTypeResponseFromJSON,
    PartTypeResponseFromJSONTyped,
    PartTypeResponseToJSON,
    PartTypeResponseToJSONTyped,
} from './PartTypeResponse';
import type { EquipmentConfigurationResponse } from './EquipmentConfigurationResponse';
import {
    EquipmentConfigurationResponseFromJSON,
    EquipmentConfigurationResponseFromJSONTyped,
    EquipmentConfigurationResponseToJSON,
    EquipmentConfigurationResponseToJSONTyped,
} from './EquipmentConfigurationResponse';

/**
 * 
 * @export
 * @interface ReferenceDataSyncItemsResponse
 */
export interface ReferenceDataSyncItemsResponse {
    /**
     * 
     * @type {Array<DataTypeResponse>}
     * @memberof ReferenceDataSyncItemsResponse
     */
    dataTypes?: Array<DataTypeResponse>;
    /**
     * 
     * @type {Array<DimensionTypeResponse>}
     * @memberof ReferenceDataSyncItemsResponse
     */
    dimensionTypes?: Array<DimensionTypeResponse>;
    /**
     * 
     * @type {Array<EquipmentCategoryResponse>}
     * @memberof ReferenceDataSyncItemsResponse
     */
    equipmentCategories?: Array<EquipmentCategoryResponse>;
    /**
     * 
     * @type {Array<EquipmentConfigurationResponse>}
     * @memberof ReferenceDataSyncItemsResponse
     */
    equipmentConfigurations?: Array<EquipmentConfigurationResponse>;
    /**
     * 
     * @type {Array<EquipmentTypeResponse>}
     * @memberof ReferenceDataSyncItemsResponse
     */
    equipmentTypes?: Array<EquipmentTypeResponse>;
    /**
     * 
     * @type {Array<InspectionCategoryResponse>}
     * @memberof ReferenceDataSyncItemsResponse
     */
    inspectionCategories?: Array<InspectionCategoryResponse>;
    /**
     * 
     * @type {Array<InspectionStatusResponse>}
     * @memberof ReferenceDataSyncItemsResponse
     */
    inspectionStatuses?: Array<InspectionStatusResponse>;
    /**
     * 
     * @type {Array<InspectionTypeResponse>}
     * @memberof ReferenceDataSyncItemsResponse
     */
    inspectionTypes?: Array<InspectionTypeResponse>;
    /**
     * 
     * @type {Array<ObservableActionTypeResponse>}
     * @memberof ReferenceDataSyncItemsResponse
     */
    observableActionTypes?: Array<ObservableActionTypeResponse>;
    /**
     * 
     * @type {Array<ObservableLevelResponse>}
     * @memberof ReferenceDataSyncItemsResponse
     */
    observableLevels?: Array<ObservableLevelResponse>;
    /**
     * 
     * @type {Array<PartCategoryResponse>}
     * @memberof ReferenceDataSyncItemsResponse
     */
    partCategories?: Array<PartCategoryResponse>;
    /**
     * 
     * @type {Array<PartLocationResponse>}
     * @memberof ReferenceDataSyncItemsResponse
     */
    partLocations?: Array<PartLocationResponse>;
    /**
     * 
     * @type {Array<PartManufacturerResponse>}
     * @memberof ReferenceDataSyncItemsResponse
     */
    partManufacturers?: Array<PartManufacturerResponse>;
    /**
     * 
     * @type {Array<PartTypeResponse>}
     * @memberof ReferenceDataSyncItemsResponse
     */
    partTypes?: Array<PartTypeResponse>;
    /**
     * 
     * @type {Array<SiteDiggingConditionResponse>}
     * @memberof ReferenceDataSyncItemsResponse
     */
    siteDiggingConditions?: Array<SiteDiggingConditionResponse>;
    /**
     * 
     * @type {Array<UnitResponse>}
     * @memberof ReferenceDataSyncItemsResponse
     */
    units?: Array<UnitResponse>;
}

/**
 * Check if a given object implements the ReferenceDataSyncItemsResponse interface.
 */
export function instanceOfReferenceDataSyncItemsResponse(value: object): value is ReferenceDataSyncItemsResponse {
    return true;
}

export function ReferenceDataSyncItemsResponseFromJSON(json: any): ReferenceDataSyncItemsResponse {
    return ReferenceDataSyncItemsResponseFromJSONTyped(json, false);
}

export function ReferenceDataSyncItemsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferenceDataSyncItemsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'dataTypes': json['dataTypes'] == null ? undefined : ((json['dataTypes'] as Array<any>).map(DataTypeResponseFromJSON)),
        'dimensionTypes': json['dimensionTypes'] == null ? undefined : ((json['dimensionTypes'] as Array<any>).map(DimensionTypeResponseFromJSON)),
        'equipmentCategories': json['equipmentCategories'] == null ? undefined : ((json['equipmentCategories'] as Array<any>).map(EquipmentCategoryResponseFromJSON)),
        'equipmentConfigurations': json['equipmentConfigurations'] == null ? undefined : ((json['equipmentConfigurations'] as Array<any>).map(EquipmentConfigurationResponseFromJSON)),
        'equipmentTypes': json['equipmentTypes'] == null ? undefined : ((json['equipmentTypes'] as Array<any>).map(EquipmentTypeResponseFromJSON)),
        'inspectionCategories': json['inspectionCategories'] == null ? undefined : ((json['inspectionCategories'] as Array<any>).map(InspectionCategoryResponseFromJSON)),
        'inspectionStatuses': json['inspectionStatuses'] == null ? undefined : ((json['inspectionStatuses'] as Array<any>).map(InspectionStatusResponseFromJSON)),
        'inspectionTypes': json['inspectionTypes'] == null ? undefined : ((json['inspectionTypes'] as Array<any>).map(InspectionTypeResponseFromJSON)),
        'observableActionTypes': json['observableActionTypes'] == null ? undefined : ((json['observableActionTypes'] as Array<any>).map(ObservableActionTypeResponseFromJSON)),
        'observableLevels': json['observableLevels'] == null ? undefined : ((json['observableLevels'] as Array<any>).map(ObservableLevelResponseFromJSON)),
        'partCategories': json['partCategories'] == null ? undefined : ((json['partCategories'] as Array<any>).map(PartCategoryResponseFromJSON)),
        'partLocations': json['partLocations'] == null ? undefined : ((json['partLocations'] as Array<any>).map(PartLocationResponseFromJSON)),
        'partManufacturers': json['partManufacturers'] == null ? undefined : ((json['partManufacturers'] as Array<any>).map(PartManufacturerResponseFromJSON)),
        'partTypes': json['partTypes'] == null ? undefined : ((json['partTypes'] as Array<any>).map(PartTypeResponseFromJSON)),
        'siteDiggingConditions': json['siteDiggingConditions'] == null ? undefined : ((json['siteDiggingConditions'] as Array<any>).map(SiteDiggingConditionResponseFromJSON)),
        'units': json['units'] == null ? undefined : ((json['units'] as Array<any>).map(UnitResponseFromJSON)),
    };
}

export function ReferenceDataSyncItemsResponseToJSON(json: any): ReferenceDataSyncItemsResponse {
    return ReferenceDataSyncItemsResponseToJSONTyped(json, false);
}

export function ReferenceDataSyncItemsResponseToJSONTyped(value?: ReferenceDataSyncItemsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dataTypes': value['dataTypes'] == null ? undefined : ((value['dataTypes'] as Array<any>).map(DataTypeResponseToJSON)),
        'dimensionTypes': value['dimensionTypes'] == null ? undefined : ((value['dimensionTypes'] as Array<any>).map(DimensionTypeResponseToJSON)),
        'equipmentCategories': value['equipmentCategories'] == null ? undefined : ((value['equipmentCategories'] as Array<any>).map(EquipmentCategoryResponseToJSON)),
        'equipmentConfigurations': value['equipmentConfigurations'] == null ? undefined : ((value['equipmentConfigurations'] as Array<any>).map(EquipmentConfigurationResponseToJSON)),
        'equipmentTypes': value['equipmentTypes'] == null ? undefined : ((value['equipmentTypes'] as Array<any>).map(EquipmentTypeResponseToJSON)),
        'inspectionCategories': value['inspectionCategories'] == null ? undefined : ((value['inspectionCategories'] as Array<any>).map(InspectionCategoryResponseToJSON)),
        'inspectionStatuses': value['inspectionStatuses'] == null ? undefined : ((value['inspectionStatuses'] as Array<any>).map(InspectionStatusResponseToJSON)),
        'inspectionTypes': value['inspectionTypes'] == null ? undefined : ((value['inspectionTypes'] as Array<any>).map(InspectionTypeResponseToJSON)),
        'observableActionTypes': value['observableActionTypes'] == null ? undefined : ((value['observableActionTypes'] as Array<any>).map(ObservableActionTypeResponseToJSON)),
        'observableLevels': value['observableLevels'] == null ? undefined : ((value['observableLevels'] as Array<any>).map(ObservableLevelResponseToJSON)),
        'partCategories': value['partCategories'] == null ? undefined : ((value['partCategories'] as Array<any>).map(PartCategoryResponseToJSON)),
        'partLocations': value['partLocations'] == null ? undefined : ((value['partLocations'] as Array<any>).map(PartLocationResponseToJSON)),
        'partManufacturers': value['partManufacturers'] == null ? undefined : ((value['partManufacturers'] as Array<any>).map(PartManufacturerResponseToJSON)),
        'partTypes': value['partTypes'] == null ? undefined : ((value['partTypes'] as Array<any>).map(PartTypeResponseToJSON)),
        'siteDiggingConditions': value['siteDiggingConditions'] == null ? undefined : ((value['siteDiggingConditions'] as Array<any>).map(SiteDiggingConditionResponseToJSON)),
        'units': value['units'] == null ? undefined : ((value['units'] as Array<any>).map(UnitResponseToJSON)),
    };
}

